import { ApolloError } from "@apollo/client";

import { createContext } from "react";
import { CacheRegistry } from "./types";
import {
  FilterValueMetaInput,
  FilterValueMeta,
  FilterValueMetaType,
} from "@towersystems/roam-common/lib/generated-types";

export type FilterMetadataContextType = {
  cachedValues: CacheRegistry;
  loading: boolean;
  error: ApolloError | undefined;
  queryMetadata(input: FilterValueMetaInput): Promise<FilterValueMeta[]>;
  addToCache(type: FilterValueMetaType, id: string, value: string): void;
  replaceCache(CacheRegistry: CacheRegistry): void;
  getFromCache(type: FilterValueMetaType, id: string): string | undefined;
};

export const FilterMetadataContext = createContext<
  FilterMetadataContextType | undefined
>(undefined);
